import {connect} from 'react-redux';

import {gettext} from 'topmeteo/utils/i18n';

import LightBox from '../../../../general/components/LightBox';

import Form from './Form';

const Description = gettext('reset-favourites-dialog-intro-text');

/* Translators: pop-up when anonymous user tries to create favorites - title */
const AnonymousHeadline = gettext('Missing subscription');

/* Translators: pop-up when anonymous user tries to create favorites - message */
const AnonymousMessage = gettext('This feature is only available for subscribers.');

/* Translators: pop-up when anonymous user tries to create favorites - label */
const AnonymousIntro = gettext('Instead you can choose a different preselection:');

const Dialog = ({isAnonymous, headline, ...props}) => (
    <LightBox {...props} headline={isAnonymous ? AnonymousHeadline : headline} hint>
        <p>{isAnonymous ? AnonymousMessage : Description}</p>
        <Form intro={isAnonymous ? AnonymousIntro : null} />
    </LightBox>
);

const mapStateToProps = ({isAnonymous}) => ({isAnonymous});

export default connect(mapStateToProps)(Dialog);
